const PREFIX = "[FRA-DEBUG]";

export function isFraDebugEnabled() {
  if (typeof window === "undefined") return false;
  try {
    if (window.__FRA_DEBUG__ === true) return true;
    if (window.location.search.includes("fra-debug=1")) return true;
    return localStorage.getItem("fra-debug") === "1";
  } catch (e) {
    return false;
  }
}

export function fraLog(step, message, data) {
  if (!isFraDebugEnabled()) return;
  const time = new Date().toISOString().substr(11, 12);
  if (data !== undefined) {
    console.log(`${PREFIX} ${time} [${step}] ${message}`, data);
  } else {
    console.log(`${PREFIX} ${time} [${step}] ${message}`);
  }
}

export function fraWarn(step, message, data) {
  if (!isFraDebugEnabled()) return;
  const time = new Date().toISOString().substr(11, 12);
  if (data !== undefined) {
    console.warn(`${PREFIX} ${time} [${step}] ${message}`, data);
  } else {
    console.warn(`${PREFIX} ${time} [${step}] ${message}`);
  }
}

/** Snapshot wall/room state after split or drag — inspect via window.__FRA_LAST_SPLIT__ */
export function fraSplitSnapshot(state, layerID, label, extra) {
  if (!isFraDebugEnabled()) return;

  const layer = state.getIn(["scene", "layers", layerID]);
  if (!layer) return;

  const lines = [];
  layer.get("lines").forEach((line, id) => {
    const v0 = layer.getIn(["vertices", line.vertices.get(0)]);
    const v1 = layer.getIn(["vertices", line.vertices.get(1)]);
    const thickness = line.getIn(["properties", "thickness"]);
    lines.push({
      id,
      isBridge: !!line.getIn(["misc", "_splitBridge"]),
      selected: line.selected,
      thickness,
      thicknessType: typeof thickness,
      lengthCm: v0 && v1 ? Math.hypot(v1.x - v0.x, v1.y - v0.y) : null,
    });
  });

  const areas = [];
  layer.get("areas").forEach((area, id) => {
    areas.push({
      id,
      visible: area.visible,
      verts: area.vertices.size,
      opacity: area.getIn(["properties", "opacity"]),
      color: area.getIn(["properties", "patternColor"]),
    });
  });

  const snapshot = {
    label,
    time: new Date().toISOString(),
    mode: state.get("mode"),
    splittedVertices: (state.get("splittedVertices") || []).toArray
      ? state.get("splittedVertices").toArray()
      : [],
    lineCount: lines.length,
    bridgeCount: lines.filter((l) => l.isBridge).length,
    areaCount: areas.length,
    lines,
    areas,
    ...extra,
  };

  if (typeof window !== "undefined") {
    window.__FRA_LAST_SPLIT__ = snapshot;
  }

  fraLog("SPLIT", label, snapshot);

  const badThickness = lines.filter(
    (l) =>
      !l.isBridge &&
      (l.thickness === undefined ||
        l.thickness === null ||
        (typeof l.thickness === "number" && !Number.isFinite(l.thickness)))
  );
  if (badThickness.length) {
    fraWarn("SPLIT", "Wall(s) with missing/invalid thickness — may render thin", {
      lineIds: badThickness.map((l) => l.id),
    });
  }

  if (snapshot.cyclesFound !== undefined && snapshot.areaCount < snapshot.cyclesFound) {
    fraWarn("SPLIT", "Fewer room areas than closed wall loops — white fill may be missing", {
      cyclesFound: snapshot.cyclesFound,
      areaCount: snapshot.areaCount,
    });
  }
}

// Run once on load when debug is on
if (typeof window !== "undefined") {
  window.enableFraDebug = function enableFraDebug() {
    localStorage.setItem("fra-debug", "1");
    console.log(`${PREFIX} Enabled — refreshing page...`);
    window.location.reload();
  };
  window.disableFraDebug = function disableFraDebug() {
    localStorage.removeItem("fra-debug");
    window.__FRA_DEBUG__ = false;
    console.log(`${PREFIX} Disabled — refreshing page...`);
    window.location.reload();
  };
  if (isFraDebugEnabled()) {
    console.log(
      `${PREFIX} Debug ON — watch logs for MOUSE | ROOM | WALL | DETECT | DIM | SPLIT`
    );
    console.log(
      `${PREFIX} After split/drag inspect: window.__FRA_LAST_SPLIT__`
    );
    console.log(
      `${PREFIX} Turn off: disableFraDebug()  or  localStorage.removeItem('fra-debug')`
    );
  }
}
